module.exports = __webpack_public_path__ + "img/news-slider2-zh.c56711d3.jpg";